import { FeatureName } from "../embed/feature-name.enum";

export enum TeamType {
    Standard = "Standard",
    Leadership = "Leadership",
    Owner = "Owner",
}

export const StandardTeamFeatures = [
    // non-optional (required for our platform)
    FeatureName.OrganisationTeam,
    FeatureName.ArchitectureRoles,
    // optional
    FeatureName.CompassValuesConstitution,
    FeatureName.OrganisationExternalDashboard,
    FeatureName.PurposeAndVision,
    FeatureName.StewardshipWorkKanban,
    FeatureName.StewardshipWorkMeetings,
];

export class TeamTypeMetadata {
    public static readonly Name: { [key in TeamType]: string } = {
        [TeamType.Standard]: "Team",
        [TeamType.Leadership]: "Organisation leaders team",
        [TeamType.Owner]: "Owner team",
    };

    // This should be kept in sync with DefaultFeaturesByTeamType in TeamBuilder.cs
    public static readonly DefaultFeatures: { [key in TeamType]: FeatureName[] } = {
        [TeamType.Standard]: [...StandardTeamFeatures],
        [TeamType.Leadership]: [
            ...StandardTeamFeatures,
            // Leader specific
            FeatureName.CulturalNetworkTeamAssessment,
            FeatureName.Progress,
        ],
        [TeamType.Owner]: [
           ...StandardTeamFeatures,
            // Leader specific
            FeatureName.Progress,
            FeatureName.CompassVision,
        ],
    };
}
